(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sms-failure-report', {
            parent: 'entity',
            params:{screen: 'SMSFailureReport'},
            url: '/sms-failure-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.SMSSettings.manageSMSReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-failure-report/sms-failure-report.html',
                    controller: 'SMSFailureReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('smsFailureReport');
                    return $translate.refresh();
                }],
                alertType: ['StaticLookUp', function(StaticLookUp) {
                    return StaticLookUp.getAlertTypes().$promise;
                }]
            }
        })
        
       
       };
    })();